<template>
  <div>
    <el-dialog
      title="添加证书"
      :visible.sync="dialogVisible"
      width="1000px"
      :before-close="handleClose"
      :append-to-body="true"
    >
      <el-form
        ref="ruleForm"
        :rules="rules"
        :model="ruleForm"
        label-width="100px"
      >
        <div style="display: flex; flex-wrap: wrap">
          <el-form-item label="证书类型" prop="certTypeId">
            <el-select
              v-model="ruleForm.certTypeId"
              @change="changeSelect"
              placeholder="请选择证书类型"
            >
              <el-option
                v-for="(item, index) in titleList"
                :key="index"
                :label="item.label"
                :value="index + 1"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="证书" prop="certTypeTwo" v-if="selectOne">
            <el-select v-model="ruleForm.certTypeTwo" placeholder="证书">
              <el-option
                v-for="(item, index) in certList"
                :label="item.label"
                :key="index"
                :value="index"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="专业" prop="major" v-if="selectOne">
            <el-input v-model="ruleForm.major"></el-input>
          </el-form-item>
        </div>
        <div style="display: flex; flex-wrap: wrap">
          <el-form-item label="发证时间" prop="certTime" v-if="selectOne">
            <el-date-picker
              type="date"
              placeholder="选择时间"
              value-format="yyyy-MM-dd"
              v-model="ruleForm.certTime"
              style="width: 100%; width: 217px"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="证书编号" prop="certCode" v-if="selectOne">
            <el-input
              v-model="ruleForm.certCode"
              style="width: 217px"
            ></el-input>
          </el-form-item>
          <el-form-item label="职称" prop="title" v-if="selectOne">
            <el-input v-model="ruleForm.title" style="width: 217px"></el-input>
          </el-form-item>
        </div>

        <el-form-item label="证书照片" prop="certPhoto">
          <el-upload
            class="avatar-uploader"
            ref="upload"
            accept=".png,.jpg,.ipeg"
            :headers="uploadHeaders"
            :action="upLoadUrl"
            :data="uploadData"
            :show-file-list="false"
            :on-success="handleSuccess"
            :before-upload="beforeAvatarUpload"
          >
            <img
              v-if="imageUrl"
              style="width: auto"
              :src="imageUrl"
              class="avatar"
            />
            <i v-else class="el-icon-plus avatar-uploader-icon"> </i>
            <!-- <div v-if="!selectOne" slot="tip" class="el-upload__tip">注：知名专家学者应为中国建筑业协会专家或国家知名专家</div> -->
          </el-upload>
        </el-form-item>
      </el-form>
      <div style="display: flex">
        <label class="el-form-item__label" style="width: 100px"
          >证书裁剪
        </label>
        <el-button type="primary" @click="openCut">点击裁剪</el-button>
      </div>

      <x-cropper ref="iscropper"></x-cropper>
      <span slot="footer" class="dialog-footer">
        <el-button
          v-if="changeShow"
          class="primary_btn"
          @click="submitForm('ruleForm')"
          >变更证书</el-button
        >
        <el-button v-else class="primary_btn" @click="submitForm('ruleForm')"
          >提交审核</el-button
        >
        <el-button @click="handleClose">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { addCert, updateCert } from "../../../api/moudles/user.js";
import { upLoadUrl, uploadHeaders, uploadData } from "@/utils/uploadConfig.js";
import xCropper from "./x-cropper.vue";
export default {
  components: {
    xCropper,
  },
  data() {
    return {
      upLoadUrl,
      uploadHeaders,
      uploadData,
      code: "",
      changeShow: false,
      selectOne: false,
      fileName: "",
      imageUrl: "",
      dialogVisible: false,
      ruleForm: {
        certTypeId: "",
        certTypeTwo: "",
        major: "",
        certTime: "",
        certCode: "",
        certPhoto: "",
      },
      newForm: {},
      titleList: [
        {
          label: "执业资格类",
        },
        {
          label: "职称类证书",
        },
        {
          label: "其他",
        },
      ],
      certList: [],
      certListOne: [
        {
          label: "一级注册建造师",
        },
        {
          label: "二级注册建造师",
        },
        {
          label: "注册建筑师",
        },
        {
          label: "注册监理工程师",
        },
        {
          label: "造价工程师",
        },
        {
          label: "注册环保工程师",
        },
        {
          label: "注册安全工程师",
        },
        {
          label: "注册结构工程师",
        },
        {
          label: "注册土木工程师",
        },
        {
          label: "注册岩土工程师",
        },
        {
          label: "注册港口与航道工程师",
        },
        {
          label: "注册水利水电工程师",
        },
        {
          label: "注册道路工程师",
        },
        {
          label: "注册电气工程师",
        },
        {
          label: "注册会计师",
        },
        {
          label: "注册经济师",
        },
      ],
      certListTwo: [
        {
          label: "初级职称",
        },
        {
          label: "中级职称",
        },
        {
          label: "副高级职称",
        },
        {
          label: "正高级职称",
        },
      ],
      certListThree: [
        {
          label: "其他",
        },
      ],
      rules: {
        certTypeId: [
          {
            required: true,
            message: "请选择证书类型",
            trigger: "change",
          },
        ],
        certTypeTwo: [
          {
            required: true,
            message: "请选择证书",
            trigger: "change",
          },
        ],
        major: [
          {
            required: true,
            message: "请输入专业",
            trigger: "blur",
          },
        ],
        certTime: [
          {
            type: "string",
            required: true,
            message: "请选择发证日期",
            trigger: "change",
          },
        ],
        certCode: [
          {
            required: true,
            message: "请输入证书编号",
            trigger: "blur",
          },
        ],
        certPhoto: [
          {
            required: true,
            message: "请上传证书照片",
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    openDialogChange(item) {
      this.changeShow = true;
      this.dialogVisible = true;
      this.selectOne = true;
      this.code = item.code;
      this.ruleForm.certTypeId = parseInt(item.certTypeId);
      const typeID = parseInt(item.certTypeId);
      if (typeID == 1) {
        this.certList = this.certListOne;
      } else if (typeID == 2) {
        this.certList = this.certListTwo;
      } else {
        this.certList = this.certListThree;
      }
      this.ruleForm.certTypeTwo = parseInt(item.certTypeTwo);
      this.ruleForm.certCode = item.certCode;
      this.ruleForm.major = item.major;
      this.ruleForm.certTime = item.certTime;
      this.ruleForm.certPhoto = item.certPhoto;
      this.ruleForm.title = item.title;
      this.ruleForm = {
        ...this.ruleForm,
      };

      this.imageUrl = item.certPhoto;
      this.newForm = item;
    },
    openDialog() {
      this.dialogVisible = true;
    },
    // 证书变更
    async updateCert(newArr) {
      await updateCert({
        data: {
          certCode: this.code,
          detail: newArr,
        },
        success: (res) => {
          if (res.code == 200 || res.code == 0) {
            this.$message({
              message: res.data,
              type: "success",
            });
            this.dialogVisible = false;
            this.$emit("refresh");
          } else {
            this.$message.error(res.msg);
          }
        },
      });
    },
    // 文件上传
    handleSuccess(file) {
      this.$message({
        message: "上传成功",
        type: "success",
      });
      this.imageUrl = file.data;
      this.ruleForm.certPhoto = file.data;
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.changeShow) {
            const newArr = [];
            Object.keys(this.ruleForm).forEach((key) => {
              if (this.newForm[key] != this.ruleForm[key]) {
                const newObj = {};
                newObj.type = key;
                newObj.changeAfter = this.ruleForm[key];
                newArr.push(newObj);
              }
            });
            if (newArr.length) {
              this.updateCert(newArr);
            } else {
              this.$message.error("您还没有修改任何信息！");
            }
          } else {
            if (!this.ruleForm.certPhoto) {
              this.$message.error("请先上传证书照片!");
              return;
            }
            this.addCert();
          }
        } else {
          return false;
        }
      });
    },
    // 新增证书
    async addCert() {
      await addCert({
        data: {
          certTypeId: this.ruleForm.certTypeId,
          certTypeTwo: this.ruleForm.certTypeTwo,
          major: this.ruleForm.major,
          certPhoto: this.ruleForm.certPhoto,
          certTime: this.ruleForm.certTime,
          certCode: this.ruleForm.certCode,
          title: this.ruleForm.title,
        },
        success: (res) => {
          if (res.code == 200 || res.code == 0) {
            this.$message({
              message: res.data,
              type: "success",
            });
            this.dialogVisible = false;
            this.$emit("refresh");
          } else {
            this.$message.error(res.msg);
          }
        },
      });
    },
    openCut() {
      this.$refs.iscropper.showModal({
        img: this.imageUrl, // 裁剪图片的地址
        outputSize: 0.8, // 裁剪生成图片的质量
        outputType: "jpeg", // 裁剪生成图片的格式
        info: true, // 裁剪框的大小信息
        canScale: false, // 图片是否允许滚轮缩放
        autoCrop: true, // 是否默认生成截图框
        autoCropWidth: 375, // 默认生成截图框宽度
        autoCropHeight: 245, // 默认生成截图框高度
        fixedNumber: [1, 1.5], // 截图框的宽高比例
        fixedBox: false, // 固定截图框大小 不允许改变
        fixed: false, // 是否开启截图框宽高固定比例
        canMove: true, // 上传图片是否可以移动
        canMoveBox: true, // 截图框能否拖动
        original: false, // 上传图片按照原始比例渲染
        centerBox: true, // 截图框是否被限制在图片里面
        infoTrue: false, // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
        full: true, // 是否输出原图比例的截图
        enlarge: "1", // 图片根据截图框输出比例倍数
        mode: "contain", // 图片默认渲染方式
        success: (res) => {
          console.log("裁剪", res);
          const blob = new Blob([res.img], { type: "image/jpeg" });

          const formData = new FormData();
          formData.append("file", blob, "cropped_image.jpg");
          fetch(this.upLoadUrl, {
            method: "POST",
            body: formData,
            headers: this.uploadHeaders,
          })
            .then((response) => response.json())
            .then((res) => {
              this.$message({
                message: "上传成功",
                type: "success",
              });
              this.imageUrl = res.data;
              this.ruleForm.certPhoto = res.data;
            })
            .catch((error) => {
              console.error("Error uploading image:", error);
            });
        },
      });
    },
    // 选择证书
    changeSelect(e) {
      if (e == 1) {
        this.selectOne = true;
        this.certList = this.certListOne;
      } else if (e == 2) {
        this.selectOne = true;
        this.certList = this.certListTwo;
      } else {
        this.selectOne = true;
        this.certList = this.certListThree;
      }
    },
    handleClose() {
      this.dialogVisible = false;
      this.selectOne = false;
      this.changeShow = false;
      this.ruleForm = {};
      this.newForm = {};
      this.imageUrl = "";
      this.$refs["ruleForm"].resetFields();
    },
    beforeAvatarUpload(file) {
      // const isJPG = file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 20;
      // if (!isJPG) {
      // 	this.$message.error('上传头像图片只能是 JPG 格式!');
      // }
      if (!isLt2M) {
        this.$message.error("上传证书图片大小不能超过 20MB!");
      }
      return isLt2M;
    },
  },
};
</script>

<style scoped>
>>> .el-dialog__footer {
  text-align: center;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 128px;
  height: 128px;
  line-height: 128px;
  text-align: center;
  border: 1px solid #dcdfe6;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.primary_btn {
  background-color: #c22c25;
  color: #fff;
}
</style>
